<script>
    import Common from "../common/index";
    // import * as commonServer from "../../../../../../api/common";

    export default {
        name: "shipin",
        mixins: [Common],
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                type: 'video',
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'UploadBtn',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'TypeList',
                        form: [
                            // {
                            //     title: '视频效果1',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                            // {
                            //     title: '视频效果2',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                        ],
                        selected: [0]
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        methods:{
            // init(){
            //     this.flashData()
            // },
            // async flashData(){
            //     let index = this.getIndexByType('TypeList')
            //     // 获取所有的视频一级目录
            //     const res = await commonServer.default[this.getResourceCategoryTree]({
            //         clientsId: this.$store.state.initConfig.school_id,
            //         sort: 'video'
            //     })
            //     console.log('获取视频列表分类==>', res.data)
            //     this.config[index].selected = []
            //     this.config[index].form = res.data.filter(v=>v.parent_id === 0).map(q=>{
            //         return {
            //             title: q.name,
            //             column: 3,
            //             data: [],
            //             ...q,
            //         }
            //     })
            //
            //     let obj = {}
            //     this.config[index].form.map(async (v,i)=>{
            //         obj = {
            //             clientsId: this.$store.state.initConfig.school_id,
            //             sort: 'video',
            //             categoryId: v.id
            //         }
            //         if (this.search) {
            //             obj.search = this.search
            //         }
            //
            //         // 数据请求地址 & 参数
            //         v.apiConfig = {
            //             params: obj,
            //             request: commonServer.default[this.getResourceList]
            //         }
            //
            //         if(i===0) {
            //             let data = await commonServer.default[this.getResourceList](obj)
            //             v.data = data.items.map(q => {
            //                 return {
            //                     url: q.attributes.resources.url, // + '?imageMogr2/thumbnail/!50p',
            //                     ...q
            //                 }
            //             })
            //
            //             // 如果第一个数据有值默认选中第一个展开
            //             if(v.data && v.data.length>0) {
            //                 this.config[index].selected = [i]
            //             }
            //         }
            //
            //         // 数据请求地址 & 参数
            //         v.apiConfig = {
            //             params: obj,
            //             request: commonServer.default[this.getResourceList]
            //         }
            //     })
            // },
            onSearchBox(search){
                this.search = search
                // this.flashData()
            }
        }
    }
</script>
